<script lang="ts">
import {
  iButton,
  iButtonSizes,
  iButtonTypes,
  iButtonStyles,
  iTooltipAlignmentMode,
  iTooltip,
} from '@inscribe/signal';
import { mapActions, mapGetters } from 'vuex';
import { registerChatAgentHookClickEvent } from '@/events-logger';

export default {
  name: 'ChatToggleButton',
  components: { iButton, iTooltip },
  props: {},
  setup() {
    return {
      iButtonSizes,
      iButtonTypes,
      iButtonStyles,
      iTooltipAlignmentMode,
    };
  },
  computed: {
    ...mapGetters(['isChatAgentEnabled']),
  },
  methods: {
    ...mapActions(['toggleChat']),
    getKeyboardShortcutLabel() {
      const isMac = navigator.userAgent.includes('Mac');
      return isMac ? '⌘I' : 'Ctrl+I';
    },
    onChatToggleButtonClick() {
      this.toggleChat();
      registerChatAgentHookClickEvent('chat-toggle-button');
    },
  },
};
</script>

<template>
  <div class="chat-button" v-if="isChatAgentEnabled">
    <i-button
      id="chat-button"
      label="Ask Assistant"
      subtype="neutral"
      :size="iButtonSizes.MEDIUM"
      :type="iButtonTypes.NEUTRAL"
      :button-style="iButtonStyles.SOLID_LIGHT"
      @button-click="onChatToggleButtonClick"
      data-dd-action-name="header-toggle-chat-panel-button"
    />
    <i-tooltip
      target="#chat-button"
      title="Ask Assistant"
      :alignment="iTooltipAlignmentMode.BOTTOM_RIGHT"
    >
      <template #tools>
        <div class="shortcut i-ml-2 i-text-body-3 i-text-neutral-90">
          {{ getKeyboardShortcutLabel() }}
        </div>
      </template>
    </i-tooltip>
  </div>
</template>

<style lang="scss" scoped>
.shortcut {
  font-family: 'Roboto Mono';
}
</style>
